import * as Yup from 'yup';

const MAX_INT = 2147483647;

const schema = Yup.object().shape({
  series: Yup.number()
    .required('Série obrigatória')
    .typeError('Série obrigatória')
    .max(MAX_INT, 'Série deve ser menor ou igual a 2147483647'),
  number: Yup.number()
    .required('Número obrigatório')
    .typeError('Número obrigatório')
    .max(MAX_INT, 'Número deve ser menor ou igual a 2147483647'),
});

export default schema;
